"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const app_1 = __importDefault(require("../app"));
const ui_1 = require("@phishtool/ui");
const index_1 = __importDefault(require("~providers/index"));
const Router = () => {
    const state = (0, ui_1.getJSONFromScriptTag)('preloaded-state');
    return ((0, jsx_runtime_1.jsx)(react_router_dom_1.BrowserRouter, { children: (0, jsx_runtime_1.jsx)(index_1.default, Object.assign({}, state, { children: (0, jsx_runtime_1.jsx)(app_1.default, {}) })) }));
};
exports.default = Router;
